import { ArrayParam, BooleanParam, JsonParam, NumberParam, ObjectParam, StringParam } from 'use-query-params'

import { FILTERS_PARAMS_KEYS, MONITORING_TASK_STATUS, MONITORING_TASK_STATUS_TITLE } from '@app/api/constants'
import { dateFormat } from '@app/constants'
import { columnSearchSchemaOptionType } from '@app/hooks/useTableSearch/сonstants'

import { LntSelectOption } from '@app/components/base/Select/types'

import type { ContractorSectionDataSource } from './types'
import type { ColumnTableSearchSchema, TableSearchQuerySchema } from '@app/hooks/useTableSearch/types'
import type { ColumnTitleSchema } from '@app/types/table'

export const columnTitleMap: ColumnTitleSchema<ContractorSectionDataSource> = {
  monitoringId: 'ID мониторинга',
  monitoringType: 'Тип мониторинга',
  date: 'Дата',
  store: 'ТК Лента',
  cluster: 'Кластер',
  status: 'Статус'
  // TODO: дополнить данные в таблице после того как бэк будет присылать корректные данные и согласовать с Никитой
  // loadingPrices: 'Загрузка цен',
  // uploadingPhotos: 'Загрузка фото',
  // matchingStatus: 'Статус сопоставления'
}

export const topFiltersQuerySchema = {
  [FILTERS_PARAMS_KEYS.monitoringTypeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.storeIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.clusterIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.salesOrganizationIds]: ArrayParam,
  [FILTERS_PARAMS_KEYS.regions]: ArrayParam,
  [FILTERS_PARAMS_KEYS.status]: ArrayParam,
  [FILTERS_PARAMS_KEYS.week]: StringParam,
  [FILTERS_PARAMS_KEYS.createdAtAfter]: StringParam,
  [FILTERS_PARAMS_KEYS.createdAtBefore]: StringParam,
  [FILTERS_PARAMS_KEYS.showStopped]: BooleanParam
}

export const tableSearchQuerySchema: TableSearchQuerySchema<ContractorSectionDataSource> = {
  'table-monitoringId': NumberParam,
  'table-monitoringType': StringParam,
  'table-date': ObjectParam,
  'table-store': StringParam,
  'table-cluster': StringParam,
  'table-status': JsonParam
} as const

const titleWrapperProps = { minWidth: 200 } as const
const titleWrapperDateProps = { minWidth: 215 } as const

const options = Object.values(MONITORING_TASK_STATUS).map<LntSelectOption>(monitoringTaskStatus => {
  return {
    label: MONITORING_TASK_STATUS_TITLE[monitoringTaskStatus],
    value: monitoringTaskStatus
  }
})

export const columnsSearchSchema: ColumnTableSearchSchema<ContractorSectionDataSource> = {
  monitoringId: { type: columnSearchSchemaOptionType.NUMERIC_INPUT, titleWrapperProps },
  monitoringType: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  date: {
    type: columnSearchSchemaOptionType.DATE_RANGE,
    titleWrapperProps: titleWrapperDateProps,
    controlProps: { format: dateFormat.DD_MM_YYYY }
  },
  store: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  cluster: { type: columnSearchSchemaOptionType.INPUT, titleWrapperProps },
  status: { type: columnSearchSchemaOptionType.SELECT, titleWrapperProps, controlProps: { options } }
}
